export default {
  en: {
    supportchat: {
      requestsupport: {
        title: "Questions?",
        text: "One of our team will be happy to help you. Just click the button below to start a chat session with us.<br><br>We aim to respond within 5 minutes, but often much sooner!",
        talktohuman: "Talk to a human",
        talktobot: "Talk to a bot",
        reportbug: "Report a bug",
        supportonline: "Support is online now!",
        supportjusthere: "Support was just here.",
        supportthishour: "Support was here within the last hour.",
        supportlongtime: "Support was here {hours} hour(s) ago.",
      },
      chatwindow: {
        leave: "Leave Chat",
        finish: "Finish chat",
        finished: 'Session has been marked as finished.',
        messageplaceholder: "Message ...",
        istyping: "is typing",
        aretyping: "are typing",
      }
    }
  },
  de: {
    supportchat: {
      requestsupport: {
        title: "Fragen?",
        text: "Eines unserer Teammitglieder hilft Ihnen gerne weiter. Klicken Sie einfach auf die Schaltfläche unten, um eine Chat-Sitzung mit uns zu starten.<br><br>Wir bemühen uns, innerhalb von 5 Minuten zu antworten, oft jedoch viel schneller!",
        talktohuman: "Mit einem Menschen sprechen",
        talktobot: "Mit einem Bot sprechen",
        reportbug: "Einen Fehler melden",
        supportonline: "Support ist jetzt online!",
        supportjusthere: "Support war gerade noch online.",
        supportthishour: "Support war in der letzten Stunde online.",
        supportlongtime: "Support war vor {hours} Stunde(n) online.",
      },
      chatwindow: {
        leave: "Chat verlassen",
        finish: "Chat beenden",
        finished: 'Die Sitzung wurde als beendet markiert.',
        messageplaceholder: "Nachricht ...",
        istyping: "schreibt",
        aretyping: "schreiben",
      }
    }
  },
  es: {
    supportchat: {
      requestsupport: {
        title: "¿Preguntas?",
        text: "Uno de los miembros de nuestro equipo estará encantado de ayudarte. Simplemente haz clic en el botón de abajo para iniciar una sesión de chat con nosotros.<br><br>¡Nuestro objetivo es responder en 5 minutos, pero a menudo mucho antes!",
        talktohuman: "Hablar con un humano",
        talktobot: "Hablar con un bot",
        reportbug: "Reportar un error",
        supportonline: "¡El soporte está en línea ahora!",
        supportjusthere: "El soporte estuvo aquí hace un momento.",
        supportthishour: "El soporte estuvo aquí en la última hora.",
        supportlongtime: "El soporte estuvo aquí hace {hours} hora(s).",
      },
      chatwindow: {
        leave: "Salir del chat",
        finish: "Terminar chat",
        finished: 'La sesión ha sido marcada como terminada.',
        messageplaceholder: "Mensaje ...",
        istyping: "está escribiendo",
        aretyping: "están escribiendo",
      }
    }
  },
  uk: {
    supportchat: {
      requestsupport: {
        title: "Питання?",
        text: "Один з наших співробітників із задоволенням допоможе вам. Просто натисніть кнопку нижче, щоб розпочати сеанс чату з нами.<br><br>Ми прагнемо відповісти протягом 5 хвилин, але часто набагато швидше!",
        talktohuman: "Поговорити з людиною",
        talktobot: "Поговорити з ботом",
        reportbug: "Повідомити про помилку",
        supportonline: "Підтримка зараз онлайн!",
        supportjusthere: "Підтримка була тут щойно.",
        supportthishour: "Підтримка була тут протягом останньої години.",
        supportlongtime: "Підтримка була тут {hours} годин(и) тому.",
      },
      chatwindow: {
        leave: "Вийти з чату",
        finish: "Завершити чат",
        finished: 'Сесію позначено як завершену.',
        messageplaceholder: "Повідомлення ...",
        istyping: "пише",
        aretyping: "пишуть",
      }
    }
  },
}
